import { Link } from "@tanstack/react-router";

import BottomMobileOptionsModal, {
  type BottomMobileOptionsModalProps,
} from "@/components/bottom-mobile-options-modal";
import { Button } from "@/components/ui/button";
import useAuth from "@/hooks/use-auth";
import { cn } from "@/lib/utils";

import { GameSortOptionsEnum } from "../../types";
import type { SortOptionsType } from "./constants";
import { SelectedIcon } from "./icons";

interface MobileModalProps
  extends Omit<BottomMobileOptionsModalProps, "title"> {
  href: string;
  isCurrentUser: boolean;
  onSignup(): void;
  options: SortOptionsType;
  sortBy: GameSortOptionsEnum;
}

export default function MobileModal({
  href,
  isCurrentUser,
  onSignup,
  options,
  sortBy,
  ...props
}: MobileModalProps) {
  const { isUser } = useAuth();

  const handleLogin = () => {
    onSignup();
    props.onOpenChange?.(false);
  };

  return (
    <BottomMobileOptionsModal title="Sort by" {...props}>
      <div className="flex flex-col items-stretch gap-2.5">
        {Object.entries(options).map(([key, { icon, name }]) => {
          if (isCurrentUser && key === GameSortOptionsEnum.USER_RATING) {
            return null;
          }

          const buttonProps: React.ComponentProps<typeof Button> = {};

          let children = (
            <>
              <span className="mr-2.5 flex w-4.5 justify-center">{icon}</span>
              {name}
              {sortBy === key && <SelectedIcon className="ml-auto" />}
            </>
          );

          if (key === GameSortOptionsEnum.MY_RATING && !isUser) {
            buttonProps.onClick = handleLogin;
          } else {
            buttonProps.asChild = true;
            buttonProps.onClick = () => props.onOpenChange?.(false);
            children = (
              <Link replace to={href + key}>
                {children}
              </Link>
            );
          }

          return (
            <Button
              className={cn(
                "flex h-[41px] w-full items-center rounded-[10px] px-2.5 text-14/[1.5em] text-white hover:bg-white/10",
                'after:ml-auto after:size-5 after:rounded-[10px] after:border after:border-white/30 after:content-[""]',
                sortBy === key ? "after:hidden" : "after:block"
              )}
              key={key}
              {...buttonProps}
            >
              {children}
            </Button>
          );
        })}
      </div>
    </BottomMobileOptionsModal>
  );
}
